import { Dialog } from '@mui/material';
import { useAuthContext } from '@emfood/shared';

import CreatePersonalFavouritesCollectionForm from '../product/product-list/create-personal-favourites-collection-form';
import CreateSharedFavouritesCollectionForm from '../product/product-list/create-shared-favourties-collection-dialog';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  currentTab: 'personal' | 'shared';
}

export default function AddFavouritesListDialog({ open, onClose, currentTab }: DialogProps) {
  const { user } = useAuthContext();
  const isCateringManager =
    user?.roles?.some((role: any) => role.name === 'Catering Manager') || false;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {currentTab === 'personal' || !isCateringManager ? (
        <CreatePersonalFavouritesCollectionForm onBack={onClose} />
      ) : (
        <CreateSharedFavouritesCollectionForm onBack={onClose} />
      )}
    </Dialog>
  );
}
